import { render, staticRenderFns } from "./ComponentOtherDeduction.vue?vue&type=template&id=8310d866&scoped=true&"
import script from "./ComponentOtherDeduction.vue?vue&type=script&lang=js&"
export * from "./ComponentOtherDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8310d866",
  null
  
)

export default component.exports